import React, { useState } from 'react'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { FORM_MERCADERIA_SIN_ANALISIS } from '../../../../config/forms'
import { obtenerTotalMercaderiaSinAnalisis, obtenerMercaderiaSinAnalisis } from '../../actions/calidad'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'
import SelectedAnioMes from '../../../Forms/SelectedAnioMes'
import MercaderiaSinAnalisisView from '../../components/calidad/MercaderiaSinAnalisisView'
import TotalMercaderiaSinAnalisisView from '../../components/calidad/TotalMercaderiaSinAnalisisView'

function MercaderiaSinAnalisis (props) {
  const { obtenerMercaderiaSinAnalisis, obtenerTotalMercaderiaSinAnalisis, change } = props
  const [show, setShow] = useState(false)

  const handleSubmit = () => {
    const { anioDescarga, mesDescarga } = props
    obtenerTotalMercaderiaSinAnalisis(anioDescarga, mesDescarga)
    obtenerMercaderiaSinAnalisis(anioDescarga, mesDescarga)
    setShow(true)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <SelectedAnioMes handleSubmit={handleSubmit} change={change} />

      { show &&
        <>
          <TotalMercaderiaSinAnalisisView />
          <MercaderiaSinAnalisisView />
        </>
      }
    </>
  )
}

const selector = formValueSelector(FORM_MERCADERIA_SIN_ANALISIS)

const mapStateToProps = (state) => ({
  anioDescarga: selector(state, 'year'),
  mesDescarga: selector(state, 'month')
})

const mapActionsToProps = {
  obtenerTotalMercaderiaSinAnalisis,
  obtenerMercaderiaSinAnalisis
}

const withReduxForm = reduxForm({
  form: FORM_MERCADERIA_SIN_ANALISIS
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(MercaderiaSinAnalisis))
